import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo from '../../../../assets/logo.svg';
import { DesktopMainMenu, MaterialUISwitch, MenuLink } from "../styles";
import { toggleTheme } from '../../../../Redux/switchTheme'
import { useDispatch, useSelector } from "react-redux";

const DesktopMenu = (props) => {
  const currentTheme = useSelector( (state) => state.LDTheme.value )
  const dispatch = useDispatch();
 
  return (
    <DesktopMainMenu >
      <MenuLink href="/" p="0px">
        <img src={logo} width="150" height='50' alt="Logo" draggable='false' />
      </MenuLink>
      <div >
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
      </div>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
